import { Link } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/uiDir/card";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/uiDir/avatar";
import { Button } from "@/components/uiDir/button";
import { Eye, ChevronRight } from "lucide-react";
import { ProfileVisitor } from "@/lib/models/dashboardmodels";

interface RecentVisitorsProps {
  visitors: ProfileVisitor[];
  getInitials: (name: string) => string;
}

export const RecentVisitors = ({ visitors, getInitials }: RecentVisitorsProps) => {
  return (
    <Card className="border-0 shadow-lg">
      <CardHeader>
        <div className="flex items-center justify-between">
          <CardTitle className="text-lg flex items-center gap-2">
            <Eye className="h-5 w-5 text-blue-600" />
            Recent Profile Visitors
          </CardTitle>
          <Link to="/dashboard/analytics">
            <Button variant="ghost" size="sm">
              View All
              <ChevronRight className="h-4 w-4 ml-1" />
            </Button>
          </Link>
        </div>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          {visitors.map((visitor) => (
            <Link key={visitor.id} to={`/profile/${visitor.viewer.username}`}>
              <div className="flex items-center gap-3 p-3 rounded-xl hover:bg-gray-50 transition-colors">
                <Avatar className="h-10 w-10"><AvatarImage src={visitor.viewer.avatar_url || `https://api.dicebear.com/7.x/avataaars/svg?seed=${visitor.viewer.username}`} /><AvatarFallback>{getInitials(visitor.viewer.full_name)}</AvatarFallback></Avatar>
                <div className="flex-1 min-w-0"><p className="font-medium text-sm">{visitor.viewer.full_name}</p><p className="text-xs text-gray-500 truncate">{visitor.viewer.title || '@' + visitor.viewer.username}</p></div>
              </div>
            </Link>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};